import React, { useState } from 'react'
import _cx from 'classnames/bind'
// @ts-ignore no types
import { slice } from 'lodash'
// @ts-ignore no types
import { Grid } from '@adc/ui-adc'
import type { PDPDisplayedDocumentsType } from '@adc/blueprint/lib/listing/pdp/types'
import { DocumentFile } from './documentFile'

const INITIAL_DISPLAY_DOCS = 6

export type DesktopViewDocumentsProps = {
  documents: PDPDisplayedDocumentsType[]
  viewDocument: (document: PDPDisplayedDocumentsType) => void
}

export type DesktopViewDocumentContainerProps = {
  doc: PDPDisplayedDocumentsType
  viewDocument: (document: PDPDisplayedDocumentsType) => void
}

const DesktopViewDocumentContainer = ({
  doc,
  viewDocument,
}: DesktopViewDocumentContainerProps) => {
  const viewSelectedDocument = () => viewDocument(doc)
  return (
    <Grid.Column computer='5' tablet='8' mobile='16'>
      <DocumentFile
        label={doc.label}
        updatedDate={doc.updatedDate}
        elmId='document_section_doc'
        viewSelectedDocument={viewSelectedDocument}
      />
    </Grid.Column>
  )
}

const DesktopViewDocuments = ({
  documents,
  viewDocument,
}: DesktopViewDocumentsProps) => {
  const [displayAll, setDisplayAll] = useState(false)

  const toggleDisplayAll = () => {
    setDisplayAll(!displayAll)
  }

  return (
    <div className='u-pt-2 u-pb-2'>
      <Grid>
        {slice(documents, 0, INITIAL_DISPLAY_DOCS).map(
          (doc: PDPDisplayedDocumentsType, i: number) => (
            <DesktopViewDocumentContainer
              key={i}
              doc={doc}
              viewDocument={viewDocument}
            />
          )
        )}
      </Grid>
      {documents.length > INITIAL_DISPLAY_DOCS &&
        (displayAll ? (
          <Grid>
            {slice(documents, INITIAL_DISPLAY_DOCS).map(
              (doc: PDPDisplayedDocumentsType, i: number) => (
                <DesktopViewDocumentContainer
                  key={i}
                  doc={doc}
                  viewDocument={viewDocument}
                />
              )
            )}
          </Grid>
        ) : (
          <div className='u-pt-5 u-stretch u-text-center'>
            <a
              data-elm-id='documents_show_all'
              onClick={toggleDisplayAll}
              title='Show All Documents'
            >
              Show All
            </a>
          </div>
        ))}
    </div>
  )
}

export default DesktopViewDocuments
